import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toggleFavorite } from "../store/features/favoritesSlice";
import { HeartIcon as HeartOutline } from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid";
import useCartItem from "../hooks/useCartItem";
import { Button, QuantityStepper } from "./ui";

// Картка лежить усередині <Link>: кнопки не повинні відкривати сторінку товару
const withoutNavigation = (fn) => (e) => {
  e.preventDefault();
  e.stopPropagation();
  fn();
};

const ProductCard = ({ product }) => {
  const dispatch = useDispatch();
  const cart = useCartItem(product);
  const isFavorite = useSelector((state) =>
    state.favorites.items.some((item) => item.product === product.id)
  );

  const discountPercent =
    product.old_price && Number(product.old_price) > Number(product.price)
      ? Math.round((1 - Number(product.price) / Number(product.old_price)) * 100)
      : 0;

  return (
    <Link
      to={`/product/${product.slug}`}
      className="bg-slate-800/70 backdrop-blur border border-slate-700 rounded-2xl overflow-hidden flex flex-col group hover:border-primary transition"
    >
      {/* IMAGE */}
      <div className="relative aspect-square overflow-hidden bg-slate-900/50">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />

        <button
          aria-label={isFavorite ? "Убрать из избранного" : "В избранное"}
          onClick={withoutNavigation(() => dispatch(toggleFavorite(product)))}
          className="absolute top-2 right-2 p-1.5 bg-slate-900/70 backdrop-blur-md border border-slate-600/60 rounded-full transition-colors hover:bg-slate-800"
        >
          {isFavorite ? (
            <HeartSolid className="w-5 h-5 text-blue-400" />
          ) : (
            <HeartOutline className="w-5 h-5 text-slate-200" />
          )}
        </button>

        {product.old_price && (
          <div className="absolute top-2 left-2 bg-red-500 text-[10px] font-bold px-2 py-0.5 rounded-full text-white">
            {discountPercent > 0 ? `−${discountPercent}%` : "СКИДКА"}
          </div>
        )}
      </div>

      {/* INFO */}
      <div className="p-3 sm:p-4 flex flex-col flex-1">
        <h3 className="text-sm font-bold text-slate-100 line-clamp-2 leading-tight mb-2">
          {product.name}
        </h3>

        <div className="mt-auto">
          <div className="flex items-baseline gap-1.5 mb-3">
            <span className="text-lg font-extrabold text-white">{product.price}</span>
            <span className="text-xs text-slate-400">zł</span>
            {product.old_price && (
              <span className="text-xs text-slate-500 line-through">{product.old_price}</span>
            )}
          </div>

          {cart.quantity === 0 ? (
            <Button variant="gradient" size="sm" block onClick={withoutNavigation(cart.add)}>
              В корзину
            </Button>
          ) : (
            <div className="flex justify-center">
              <QuantityStepper
                size="sm"
                quantity={cart.quantity}
                onDecrease={withoutNavigation(cart.decrease)}
                onIncrease={withoutNavigation(cart.increase)}
              />
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
